export var Platform;
(function (Platform) {
    Platform["Twitch"] = "twitch";
    Platform["TikTok"] = "tiktok";
    Platform["YouTube"] = "youtube";
})(Platform || (Platform = {}));
export var DarePlatform;
(function (DarePlatform) {
    DarePlatform["Twitch"] = "twitch";
    DarePlatform["TikTok"] = "tiktok";
    DarePlatform["YouTube"] = "youtube";
    DarePlatform["YouTubeShorts"] = "youtubeShorts";
    DarePlatform["X"] = "x";
})(DarePlatform || (DarePlatform = {}));
